import { render, staticRenderFns } from "./vascularPlant.vue?vue&type=template&id=5fdeeca6&scoped=true&"
import script from "./vascularPlant.vue?vue&type=script&lang=js&"
export * from "./vascularPlant.vue?vue&type=script&lang=js&"
import style0 from "./vascularPlant.vue?vue&type=style&index=0&id=5fdeeca6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdeeca6",
  null
  
)

export default component.exports